<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>控制中心</b-breadcrumb-item>
            <b-breadcrumb-item active>分店管理</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row mb-2">
        <div class="col-12 col-xl-8 d-flex items-center">
          <h4 class="font-weight-bold">分店管理</h4>
        </div>
        <div class="col-12 col-xl-4">
          <b-input-group>
            <b-form-input
              placeholder="搜尋分店編號或店名"
              v-model="query.query"
              @keyup.enter="handlePageReset"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="handlePageReset"
                ><i class="fa fa-search"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div
        class="d-flex flex-column flex-xl-row mt-4 mb-3 justify-content-between"
      >
        <b-breadcrumb class="mb-2 p-0" :items="breadcrumb"></b-breadcrumb>
        <div>
          <b-dropdown v-if="$permissions.has($permissions.consts.BRANCH_LIST_VIEW)" class="flex-shrink-0 mb-2 ml-2" variant="inverse-info">
            <template #button-content>
              <span class="mdi mdi-download"></span> 資料匯出
            </template>
            <b-dropdown-item @click="exportBranches">分店資料匯出</b-dropdown-item>
            <b-dropdown-item v-if="$permissions.has($permissions.consts.BRANCH_REGISTER_URL_EXPORT)" @click="exportBranchesQrCodes">分店註冊QRCode圖片匯出</b-dropdown-item>
            <b-dropdown-item v-if="$permissions.has($permissions.consts.BRANCH_TO_OA_URL_EXPORT)" @click="exportBranchesOaQrCodes">分店轉導OA QRCode圖片匯出</b-dropdown-item>
          </b-dropdown>
          <b-button
            v-if="$permissions.has($permissions.consts.BRANCH_IMPORT_TW_CITY) && $route.name !== 'Branches' && (activeBranch && activeBranch.level < 6) && !$route.query.query"
            class="ml-4"
            variant="primary"
            :disabled="activeBranch && activeBranch.branch_type === 'shop'"
            @click="generateTwBranch"
          >
            <i class="fa fa-plus"></i>
            匯入台灣縣市
          </b-button>
          <b-button
            v-if="showCreateButton && !$route.query.query && !this.branchID"
            variant="primary"
            class="ml-4"
            :disabled="activeBranch && activeBranch.branch_type === 'shop'"
            @click="handleUpload(true)"
          >
            <i class="fa fa-plus"></i>上傳最上層分店
          </b-button>
          <b-button
            v-if="showUploadButton"
            variant="primary"
            class="ml-4"
            :disabled="activeBranch && activeBranch.branch_type === 'shop'"
            @click="handleUpload(false)"
          >
            <i class="fa fa-plus"></i>上傳分店
          </b-button>
          <b-button
            v-if="showCreateButton && !$route.query.query"
            class="ml-4"
            variant="primary"
            :disabled="activeBranch && activeBranch.branch_type === 'shop'"
            @click="handleCreate"
          >
            <i class="fa fa-plus"></i>
            {{ $route.name === "Branches" ? "新增最上層分店" : "新增分店" }}
          </b-button>
        </div>
      </div>

      <div v-if="(activeBranch && activeBranch.branch_type === 'area') || !branchID" class="mb-3 p-2">
        <span>分區數目：{{ branchStats?.area_count || 0 }}</span><br/>
        <span>門市數目：{{ branchStats?.shop_count || 0 }}</span>
      </div>

      <b-table
        striped
        hover
        responsive
        :items="branches"
        :fields="fields"
        :busy="isLoading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(branch_code)="data">
          <router-link
            :to="{ name: 'BranchesShow', params: { branchID: data.item.id } }"
            >{{ data.item.branch_code }}</router-link
          >
        </template>
        <template #cell(is_enabled)="data">
          <b-badge
            :variant="
                !!data.item.is_enabled === true ? 'success' : 'secondary'
              "
            class="mr-1"
          >{{
              !!data.item.is_enabled === true ? "啟用" : "停用"
            }}</b-badge
          >
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            class="ml-2"
            variant="secondary"
          >
            <template slot="button-content">
              <i class="mdi mdi-menu"></i>
            </template>

            <b-dropdown-item
              :to="{
                name: 'BranchUpdateImage',
                params: {
                  branchID: data.item.id,
                },
              }"
            >
              設定圖片
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$permissions.has($permissions.consts.BRANCH_CONFIG_MENU)"
              :to="{
                name: 'BranchMenuEditor',
                params: {
                  branchID: data.item.id,
                },
              }"
            >
              分店選單
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                $permissions.hasAny([
                  $permissions.consts.BRANCH_DETAIL_VIEW_STAFF,
                  $permissions.consts.BRANCH_DETAIL_DELETE_STAFF,
                  $permissions.consts.BRANCH_DETAIL_CHANGE_PASSWORD,
                ])
              "
              :to="{
                name: 'BranchStaffs',
                params: {
                  branchID: data.item.id,
                },
              }"
            >
              店內帳號
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$permissions.has($permissions.consts.BRANCH_CONFIG_SERVICE)"
              v-b-modal="'modal-branch-settings'"
              @click="modalChoosedBranch = data.item"
            >
              分店服務設定
            </b-dropdown-item>

            <b-dropdown-item
              v-if="showDisableButton"
              @click="
                handleUpdateEnabled(data.item.id, data.item, !data.item.is_enabled)
              "
            >
              {{ data.item.is_enabled ? "停用分店" : "啟用分店" }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            class="ml-2"
            variant="inverse-info"
            v-if="!activeBranch || (activeBranch && activeBranch.level < 6)"
            :to="{
              name: 'BranchesSubLayer',
              params: {
                branchID: data.item.id,
              },
            }"
            :disabled="
              (activeBranch && activeBranch.branch_type === 'shop') ||
              data.item.branch_type === 'shop'
            "
          >
            <span class="mdi mdi-sitemap mr-1"></span>下層
          </b-button>
          <b-button
            class="ml-2"
            :to="{ name: 'BranchesShow', params: { branchID: data.item.id } }"
            variant="inverse-primary"
          >
            <span class="mdi mdi-eye mr-1"></span>查看
          </b-button>
          <b-button
            class="ml-2"
            v-if="showModifyButton"
            variant="inverse-warning"
            :to="{
              name: 'BranchesEdit',
              params: {
                branchID: data.item.id,
              },
            }"
          >
            <span class="mdi mdi-lead-pencil mr-1"></span>編輯
          </b-button>
          <b-button
            v-if="showDeleteButton"
            class="ml-2"
            variant="inverse-danger"
            @click="
              handleDelete(data.item.id, data.item.branch_code, data.item.name)
            "
          >
            <span class="mdi mdi-delete mr-1"></span>刪除
          </b-button>
        </template>
      </b-table>

      <CustomPagination
        :currentPage="query.page"
        :totalRows="total"
        :perPage="query.per_page"
        @page-change="handlePageChange"
        @per-page-change="handlePerPageChange"
      />
    </b-card>

    <b-modal
      id="modal-branch-settings"
      :title="modalChoosedBranch?.name"
      centered
      @hidden="modalChoosedBranch = null"
      @ok="handleBranchConfigSave"
    >
      <b-form-checkbox-group 
        v-model="safeBranchConfigService" 
        name="services" 
        class="mb-3"
      >
        <b-form-checkbox value="nearby">鄰近分店</b-form-checkbox>
        <b-form-checkbox value="booking">預約</b-form-checkbox>
      </b-form-checkbox-group>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from "vuex";
import branchApi from "../../../apis/branch";
import * as consts from "@/consts";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";

export default {
  components: { CustomPagination },
  mixins: [paginationMixin],
  data() {
    return {
      modalChoosedBranch: null,
      consts,
      isLoading: false,
      search: "",
      branches: [],
      activeBranch: null,
      branchStats: null,
      fields: [
        {
          key: "order",
          label: "順序",
        },
        {
          key: "branch_type",
          label: "類型",
          formatter: (value) => {
            return value === "shop" ? "門市" : "分區";
          },
        },
        {
          key: "name",
          label: "名稱",
        },
        {
          key: "branch_code",
          label: "編號代碼",
        },
        {
          key: "is_enabled",
          label: "狀態",
        },
        {
          key: "actions",
          label: "管理",
        },
      ],
      total: 0,
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        query: "",
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    breadcrumb() {
      const root = {
        text: "最上層",
        to: {
          name: "Branches",
        },
      };

      const parents =
        this.activeBranch?.parents.map((parent) => {
          return {
            text: parent.parent_name,
            to: {
              name: "BranchesSubLayer",
              params: { branchID: parent.parent_id },
            },
          };
        }) ?? [];

      const active = {
        text: this.activeBranch?.name,
        href: "#",
        active: true,
      };

      return this.activeBranch ? [root, ...parents, active] : [root, active];
    },
    branchID() {
      return this.$route.params.branchID;
    },
    showCreateButton() {
      if (this.$route.name === "Branches") {
        return this.$permissions.has(
          this.$permissions.consts.BRANCH_TOP_CREATE
        );
      }
      return this.$permissions.has(this.$permissions.consts.BRANCH_CREATE)
    },
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    showUploadButton() {
      return this.$permissions.has(this.$permissions.consts.BRANCH_CREATE);
    },
    showModifyButton() {
      return this.$route.name === "Branches"
        ? this.$permissions.has(this.$permissions.consts.BRANCH_TOP_MODIFY)
        : this.$permissions.has(this.$permissions.consts.BRANCH_MODIFY);
    },
    showDeleteButton() {
      return this.$route.name === "Branches"
        ? this.$permissions.has(this.$permissions.consts.BRANCH_TOP_DELETE)
        : this.$permissions.has(this.$permissions.consts.BRANCH_DELETE);
    },
    showDisableButton() {
      return this.$route.name === "Branches"
        ? this.$permissions.has(this.$permissions.consts.BRANCH_TOP_DISABLE)
        : this.$permissions.has(this.$permissions.consts.BRANCH_DISABLE);
    },
    safeBranchConfigService: {
      get() {
        return this.modalChoosedBranch?.config?.service ?? [];
      },
      set(val) {
        if (!this.modalChoosedBranch.config) {
          this.modalChoosedBranch.config = {};
        }
        this.modalChoosedBranch.config.service = val;
      }
    }
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  mounted() {
    this.fetchBranches();
    this.fetchBranchStats();

    if (this.branchID) {
      this.fetchActiveBranch();
    }
    this.initialized = true;
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      const defaultQuery = { page: 1, per_page: this.query.per_page || 10 };
      this.query = { ...defaultQuery, ...to.query };
      updateQueryFromRoute(to, this.$store, this.query);
      this.fetchBranches();
      this.fetchBranchStats();
      if (this.branchID) {
        this.fetchActiveBranch();
      }
    },
  },
  methods: {
    async fetchBranches() {
      try {
        this.isLoading = true;
        // only_my_branch 會拉此會員第一層的分店，有兩個情境下會是 false
        // - 如果已經有明確指定要拉的子店時(this.$route.params.branchID 有值時)
        // - 如果有 BRANCH_TOP_VIEW 顯示最上層的權限，就不會只看會員的第一層，而是要看最上層的分店
        const { data } = await branchApi.getBranches(this.organization, {
          only_my_branch:
            !this.$route.params.branchID &&
            !this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW),
          parent_id: this.$route.params.branchID || "",
          ...this.query,
        });
        this.total = data.meta.total;
        this.branches = data.data;
      } catch (error) {
        console.log("");
      }
      this.isLoading = false;
    },
    async exportBranches() {
      try {
        this.isLoading = true;
        await branchApi.exportBranches(this.organization, {
          only_my_branch:
            !this.$route.params.branchID &&
            !this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW),
          parent_id: this.$route.params.branchID || "",
          ...this.query,
        }).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }

            this.isLoading = false;
          });
        });
      } catch (e) {
        console.log(e)
      }
    },
    async exportBranchesWithUrl() {
      try {
        this.isLoading = true;
        await branchApi.exportBranchesWithUrl(this.organization, {
          only_my_branch:
            !this.$route.params.branchID &&
            !this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW),
          parent_id: this.$route.params.branchID || "",
          ...this.query,
        }).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }

            this.isLoading = false;
          });
        });
      } catch (e) {
        console.log(e)
      }
    },
    async exportBranchesQrCodes() {
      try {
        this.isLoading = true;
        await branchApi.exportBranchesQrCodes(this.organization, {
          only_my_branch:
            !this.$route.params.branchID &&
            !this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW),
          parent_id: this.$route.params.branchID || "",
          ...this.query,
        }).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }

            this.isLoading = false;
          });
        });
      } catch (e) {
        console.log(e)
      }
    },
    async exportBranchesOaQrCodes() {
      try {
        this.isLoading = true;
        await branchApi.exportBranchesOaQrCodes(this.organization, {
          only_my_branch:
            !this.$route.params.branchID &&
            !this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW),
          parent_id: this.$route.params.branchID || "",
          ...this.query,
        }).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }

            this.isLoading = false;
          });
        });
      } catch (e) {
        console.log(e)
      }
    },
    async fetchActiveBranch() {
      try {
        const { data } = await branchApi.getBranch(this.branchID);

        this.activeBranch = data.data;
      } catch (error) {
        console.log("");
      }
    },
    async fetchBranchStats() {
      try {
        const params = {
          branch_id: this.branchID,
        };

        const { data } = await branchApi.getBranchStats(this.organization, params);

        this.branchStats = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async handleDelete(branchID, branchCode, branchName) {
      this.$swal
        .fire({
          type: "warning",
          title: `您確定要刪除 ${branchName} 與所有下層分店嗎？`,
          html: `
            <div class="d-block">
              <div class="my-3">
                <div>店名：${branchName}</div>
                <div>分店編號：${branchCode}</div>
              </div>
              <div>刪除後，相關資料將無法回復，<br/>請您確認！</div>
            </div>`,
          confirmButtonText: "確定刪除全部",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              this.isLoading = true;
              await branchApi.deleteBranch(branchID);
              await this.fetchBranches();
            } catch (error) {
              console.log("");
            }
            this.isLoading = false;
          }
        });
    },
    handleUpload(isTop) {
      if (this.activeBranch) {
        this.$router.push({
          name: "BranchesImport",
          params: {
            branchID: this.branchID,
          },
        });
      } else {
        this.$router.push({
          name: "BranchesRootImport",
          params: {
            isTop: isTop
          }
        });
      }
    },
    async handleUpdateEnabled(id, branch, flag) {
      const isArea = branch.branch_type === 'area';
      const isEnable = flag;

      let titleMessage = `您確定要${isEnable ? '啟用' : '停用'} ${branch.name}${isArea ? ' 與所有下層分店' : ''}嗎？`;

      // 按鈕文字
      const confirmButtonText = isEnable ? `確定${isArea ? '啟用全部' : '啟用'}` : `確定${isArea ? '停用全部' : '停用'}`;
      const cancelButtonText = isEnable ? `不${isArea ? '啟用' : '啟用'}` : `不${isArea ? '停用' : '停用'}`;

      // 按鈕顏色（紅色表示停用，藍色表示啟用）
      const confirmButtonColor = isEnable ? "#3085d6" : "#d33";
      const cancelButtonColor = isEnable ? "#d33" : "#3085d6";

      this.$swal.fire({
        title: titleMessage,
        type: "warning",
        html: `
      <div class="d-block">
        <div class="my-3">
          <div>店名：${branch.name}</div>
          <div>分店編號：${branch.branch_code}</div>
        </div>
      </div>`,
        confirmButtonText,
        cancelButtonText,
        showCancelButton: true,
        confirmButtonColor,
        cancelButtonColor,
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.isLoading = true;
            await branchApi.changeBranchEnabled(id, {
              is_enabled: flag,
            });
            this.fetchBranches();
          } catch (error) {
            console.log(error);
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    async generateTwBranch() {
      this.$swal.fire({
        title: `是否匯入台灣縣市至 ${this.activeBranch.name}？`,
        type: "warning",
        confirmButtonText: "是",
        cancelButtonText: "否",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.isLoading = true;
            await branchApi.generateTwBranches(this.branchID, {})
              .then(() => {
                this.fetchBranches();
              });
            this.isLoading = false;
          } catch (error) {
            console.log(error)
          }
        }
      });
    },
    handleCreate() {
      if (this.activeBranch) {
        this.$router.push({
          name: "BranchesCreate",
          params: {
            branchID: this.branchID,
          },
        });
      } else {
        this.$router.push({
          name: "BranchesRootCreate",
        });
      }
    },
    handleBranchConfigSave() {
      console.log(this.modalChoosedBranch);
      branchApi.updateBranchServiceConfig(
        this.modalChoosedBranch.id,
        { service: this.modalChoosedBranch.config.service }
      ).then(() => {
        this.$swal.fire({
          title: '成功',
          text: "分店服務設定已更新",
          type: 'success',
        });
        this.fetchBranches();
      }).catch(() => {
        this.$swal.fire({
          title: '失敗',
          text: "分店服務設定更新失敗，請稍後再試",
          type: 'error',
        });
      })
    },
    test(){
      console.log(this.modalChoosedBranch)
    }
  },
};
</script>
